/* eslint-disable */
import React, { useCallback, useState, useEffect, useImperativeHandle, forwardRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useMount, useUpdateEffect, usePrevious } from 'react-use'
import { Link } from 'react-router-dom'
import dayjs from 'dayjs'
import qs from 'qs'
import { Input, Button, Modal, message, Avatar, Table, Tag, Breadcrumb, Divider } from 'antd'
import * as actions from '@/models/notifies/actions';
import * as selectors from '@/models/notifies/selectors'
import * as services from '@/models/notifies/services'
import styles from './notifies.module.scss'

const feedbackType= {
  1: "体验问题" ,
  2: "新功能建议" ,
  3: "功能异常" ,
  4: "服务类目不合理" ,
}

function getColumns({ fetch, setVisibleItem }) {
  const dispatch = useDispatch()
  const deleteManager = item => {
    services.deleteFeedbackitem(item._id).then(res => {
      fetch()
    }).catch((err) => {
      message.error(err?.message || '删除失败，请刷新重试');
    }).finally(() => { });

  }

  const ignoreManager = item => {
    services.ignoreFeedbackitem(item._id).then(res => {
      fetch()
    }).catch((err) => {
      message.error(err?.message || '操作失败，请刷新重试');
    }).finally(() => { });

  }
  return [
    {
      key: '_id',
      title: '编号',
      width:60,
      render: (text, record, idx) => <div style={{ whiteSpace: 'nowrap' }}>{idx + 1}</div>
    },
    {
      title: '用户',
      render: item => (
        <div>
          <div>{item?.worker?.realname || (item?.retailInvestor?.user?.name || '用户'+item?.retailInvestor?.user?.mobile.slice(-4))}</div>
        </div>
      )
    },
    {
      title: '联系方式',
      render: item => (
        <div>
          <div>{item?.contact}</div>
        </div>
      )
    },
    {
      title: '反馈描述',
      render: item => (
        <div>
          <div>{item?.desc}</div>
        </div>
      )
    },
    {
      title: '反馈图片',
      render: item => (
        <div>
          {item?.imgs && Array.isArray(item.imgs) ? (
            item.imgs.map((img, index) => (
              <div key={index} style={{ display: 'inline-block', marginRight: 8, marginBottom: 4 }}>
                <a target="_blank" href={img}>
                  <img src={img} style={{ width: 48, height: 48 }} />
                </a>
              </div>
            ))
          ) : item?.imgs ? (
            <div><a target="_blank" href={item.imgs}><img src={item.imgs} style={{ width: 48, height: 48 }} /></a></div>
          ) : (
            <div>-</div>
          )}
        </div>
      )
    },
    {
      title: '反馈类型',
      render: item => (
        <div>
          <div>{feedbackType[item.type]||'-'}</div>
        </div>
      )
    },
    {
      title: '反馈时间',
      render: item => (
        <div>
          {item.createdAt ? dayjs(item.createdAt).fromNow() : '-'}
        </div>
      )
    },
    {
      title: '状态',
      render: item => (
        <div>
          <div>{item.status ? '已回应' : '未回应'}</div>
        </div>
      )
    },
    {
      title: '回应',
      render: item => (
        <div>
          <div>{item.reply}</div>
        </div>
      )
    },
    {
      title: '回应时间',
      render: item => (
        <div>
          {item.replyAt ? dayjs(item.replyAt).fromNow() : '-'}
        </div>
      )
    },

    {
      title: '操作',
      render: item => {
        return (
          <div>
            {item.status ?
              <a onClick={() => { deleteManager(item) }}>删除</a> :
              (<><a onClick={() => { ignoreManager(item) }}>忽略</a> ｜ <a onClick={() => { setVisibleItem(item) }}>回应</a></>) 
            }
           
          </div>
        )
      }
    }
  ]
}

function Feedback(props, ref) {
  const dispatch = useDispatch()

  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [mgroups, setMgroups] = useState([]);
  const [visibleItem, setVisibleItem] = useState(null);
  const [inputValue, setInputValue] = useState('');

  useImperativeHandle(ref, () => ({
    add() {
      showInfoDialog('添加分组')
    },
  }));

  const pagination = {
    showQuickJumper: true,
    total: total,
    pageSize: +limit,
    current: Math.floor(offset / +limit) + 1
  }
  const fetch = useCallback((params = {}) => {
    params.offset = params.offset || offset
    params.limit = params.limit || limit
    setLimit(params.limit)
    setOffset(params.offset)
    setLoading(true)
    services.fetchFeedbackList(params).then(res => {
      setMgroups(res.data || [])
      setTotal(res.total||0)
    }).catch((err) => {
      message.error(err?.message || '获取列表失败，请刷新重试');
    }).finally(() => { setLoading(false) });
  }, [])


  const handleTableChange = useCallback((pagination, filters, sorter) => {
    const nextQuery = {
      ...filters,
      offset: (pagination.current - 1) * pagination.pageSize
    }

    if (sorter && sorter.field) {
      nextQuery.sort = (sorter.order && sorter.order === 'descend' ? '' : '-') + sorter.field
    }
    fetch(nextQuery)
  })

  const handleOk = () => {
    if (!inputValue) {
      return message.info('请输入回复内容');
    }
    services.feedbackReply({
      id: visibleItem._id,
      reply: inputValue
    }).then(res => {
      fetch()
      setInputValue('')
      setVisibleItem(null)
    }).catch((err) => {
      message.error(err?.message || '提交失败，请刷新重试');
    }).finally(() => { });
  }
  const columns = getColumns({ fetch, setVisibleItem })

  useMount(() => {
    fetch()
  })

  return (
    <div className={styles.container}>
      <Table
        className={styles.table}
        columns={columns}
        rowKey="_id"
        dataSource={mgroups}
        pagination={pagination}
        onChange={handleTableChange}
        loading={loading}></Table>
      <Modal
        title="回复"
        visible={!!visibleItem}
        onOk={() => { handleOk()}}
        onCancel={() => {
          setInputValue('')
          setVisibleItem(null)
         }}
      >
        <Input.TextArea value={inputValue} rows={5} placeholder="请输入回复内容"
          onChange={(e) => { setInputValue(e.target.value) }}
        />
      </Modal>
    </div>
  )
}

export default forwardRef(Feedback)
